import { authenticatedRestClient } from 'helpers/restclient';
import qs from 'qs';

export default class DealershipServices {
	static instance = new DealershipServices();

	_endpoints = {
		dealership: (dealershipId) => `/api/dealerships/${dealershipId}`,
		getDealershipForSettings: (dealershipId) => `/api/settings/dealerships/${dealershipId}`,
		// dealership addresses
		addresses: (dealershipId) => `/api/v4/dealerships/${dealershipId}/addresses`,
		updateAddress: (dealershipId, addressId) => `/api/v4/dealerships/${dealershipId}/addresses/${addressId}`,
		deleteAddress: (dealershipId, addressId) => `/api/v4/dealerships/${dealershipId}/addresses/${addressId}`,
		createAddress: (dealershipId) => `/api/v4/dealerships/${dealershipId}/addresses`,
	};

	constructor() {
		this.restClient = authenticatedRestClient;
	}

	getDealership = (dealershipId) => {
		const endpoint = this._endpoints.dealership(dealershipId);
		return this.restClient.get(endpoint);
	};

	getDealershipForSettings = (dealershipId) => {
		const endpoint = this._endpoints.getDealershipForSettings(dealershipId);
		return this.restClient.get(endpoint);
	};

	getDealershipAddresses = (dealershipId, types = [], page) => {
		const endpoint = this._endpoints.addresses(dealershipId);
		const query = qs.stringify({ types, page }, { addQueryPrefix: true, arrayFormat: 'brackets' });

		return this.restClient.get(`${endpoint}${query}`);
	};

	updateAddress = (dealershipId, addressId, data) => {
		const endpoint = this._endpoints.updateAddress(dealershipId, addressId);
		return this.restClient.put(endpoint, data);
	};

	deleteAddress = (dealershipId, addressId) => {
		const endpoint = this._endpoints.deleteAddress(dealershipId, addressId);
		return this.restClient.delete(endpoint);
	};

	createAddress = (dealershipId, data) => {
		const endpoint = this._endpoints.createAddress(dealershipId);
		return this.restClient.post(endpoint, data);
	};
}
